export default{
    newsFourTitle: "Able to Accelerate Credit Distribution, These are 4 Advantages of Credit Scoring",
    newsFourTime: "pubdate",
    newsFourRead:"Pageviews",
    newsFourSource:"Article source:",
    newsFourDetail:[
        {
            p:"Rafki Fachrizal - Wednesday, January 6, 2021 | 12:30 WIB"
        },
        {
            p:"As a result of the COVID-19 pandemic, which is still happening today, it was recorded that during 2020 credit distribution in Indonesia experienced a slowdown."
        },
        {
            p:"Apart from the pandemic that has created economic pressure, the gap between public credit needs and the distribution of funds from financial institutions is also a crucial issue."
        },
        {
            p:"For financial institutions themselves, one of the biggest challenges in lending is the limited credit history of individuals."
        },
        {
            p:"For example, informal business owners who do not have bookkeeping, or young employees who are just starting their careers, so it is difficult to get credit from conventional financial institutions."
        },
        {
            p:"One of the keys to bridging the credit gap in Indonesia so that it is able to accelerate credit distribution is by developing credit scoring technology (credit score) through innovation and increasing variety of assessment data."
        },

        {
            p:"Currently, credit score technology itself has been widely applied by many fintech companies (financial technology) in presenting their credit services"
        },
        {
            p:"Credit score technology is able to analyze the profile of prospective borrowers more quickly, efficiently, comprehensively, and reduce data habits."
        },
        {
            p:"Paramananda Setyawan, Chief Data Officer of Kredivo, said, “The adoption of machine learning using a combination of traditional data and alternative data allows fintechs to analyze users' credit scores with bank-level metrics, in a faster and more efficient manner. This alternative can be one of the solutions to address the challenges of the credit gap in Indonesia.”"
        },
        {
            p:"Paramananda continued, until now Kredivo's credit score technology has assessed the creditworthiness of more than 500 thousand users per month and is able to channel credit to more than 2 million users or 25% of the current credit card user base."
        },
        {
            p:'"More than 60% of the total users get their first credit access through Kredivo," said Paramananda.'
        },
        {
            p:'Furthermore, there are at least 4 advantages of credit scoring innovation compared to conservative credit analysis methods, including:'
        },
        {
            h4:'1. Improve the quality of creditworthiness assessment'
        },
        {
            p:'People who have a low credit score are certainly difficult to get credit. Credit score innovation allows creditors to determine the ability of prospective debtors by analyzing other alternative data such as behavior when registering and spending patterns.'
        },
        {
            p:'"Various alternative data sources used for the assessment process help us produce a faster and more accurate analysis, which of course still prioritizes the protection of user privacy in accordance with current regulatory provisions, namely the limitation of digital data that can be accessed from smartphones only through cameras, microphones, and location,” added Paramananda.'
        },
        {
            h4:'2. Expanding access to credit and accelerating credit absorption'
        },
        {
            p:'People such as novice workers with limited credit history and novice entrepreneurs are among the people who still find it difficult to get access to credit conventionally.'
        },
        {
            p:'Through credit score innovation, they have the opportunity to access credit quickly and easily.'
        },
        {
            p:'Even if the analysis carried out from various alternative data shows good results, they will get a high credit score and get a loan with a large nominal.'
        },
        {
            p:'In addition, credit score innovation also allows for faster credit absorption, especially for MSME players.'
        },
        {
            h4:'3. More accurate and real-time data presentation'
        },
        {
            p:'In a conservative credit score process, a prospective debtor‘s bad credit history will affect the results of the analysis, for at least 1-2 years after the credit process occurs.'
        },
        {
            p:'Prospective debtors will take a long time to recover their credit history and obtain a good credit score.'
        },
        {
            p:'So, if a prospective debtor failed to pay 2 years ago, he is still considered a potentially risky profile at this time even though his financial condition has improved rapidly in the last 2 years.'
        },
        {
            p:'However, various alternative data used in innovative credit score analysis is real-time data so that it can be a solution for those who have experienced default.'
        },
        {
            h4:'4. Reducing information bias'
        },
        {
            p:'Innovations designed by fintechs have had a major impact on the level of financial inclusion in various countries.'
        },
        {
            p:'Fintech utilizes automated digital technology and tools to reduce bias due to human error factors.'
        },
        {
            p:'The algorithm used by fintech is able to provide accurate analysis results according to the user’s risk profile.'
        },

    ]
}